


import { ProductCategory } from '@/components/products/product-categories/ProductCategory'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ProductCategories extends Vue {
  @Prop({ default: null }) excludedId!: number | null
  categories: ProductCategory[] = []

  get visibleCategories() {
    return this.excludedId
      ? this.categories.filter(category => category.id !== this.excludedId)
      : this.categories
  }

  async created() {
    const { data } = await this.$axios.get<ProductCategory[]>('/product-categories', {
      params: {
        _sort: 'id:asc'
      }
    })
    this.categories = data
  }
}
